import React from "react";
import classNames from "classnames";

import styles from "./Title.module.scss";

interface TitleProps extends React.HTMLAttributes<HTMLSpanElement> {
  tagName?: keyof Pick<
    JSX.IntrinsicElements,
    "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span"
  >;
  size?: "small" | "normal" | "large" | "xlarge";
  light?: boolean;
  stable?: boolean;
}

const Title: React.FC<TitleProps> = ({
  tagName: El = "span",
  children,
  className,
  size = "normal",
  light,
  stable,
  ...props
}) => {
  return (
    <El
      className={classNames(
        styles.title,
        styles[size],
        { [styles.light]: light },
        { [styles.stable]: stable },
        className
      )}
      {...props}
    >
      {children}
    </El>
  );
};

export { Title };
